<i18n>
{
  "en": {
    "title": "Help and support",
    "description": "If you are experiencing any problems with the platform, please contact us by one of the following means:",
    "videoDescription": "If you need more information about how to interact with the platform and procedures, the following playlist of tutorial videos are at your disposal:",
    "accept": "Accept",
    "phone": "Phone"
  },
  "es": {
    "title": "Soporte y ayuda",
    "description": "Si está experimentando algún problema con la plataforma, por favor, contacte con nosotros mediante alguno de los siguientes medios:",
    "videoDescription": "Si necesita información acerca de cómo interactuar con la plataforma y sus procesos, tiene a su disposición la siguiente lista de videos explicativos:",
    "accept": "Aceptar",
    "phone": "Teléfono"
  }
}
</i18n>

<template>
  <v-dialog v-model="visible" max-width="750" @click:outside="$emit('close')"
            @keydown.esc="$emit('close')">
    <v-card>
      <v-card-title class="text-h5 primary white--text">{{ $t('title') }}</v-card-title>
      <v-card-text class="mt-2">{{ $t('description') }}</v-card-text>
      <v-card-text class="d-flex justify-center">
        <v-icon class="mr-1">mdi-email</v-icon>
        E-mail: <a class="ml-2" :href="`mailto:${this.supportEmail}`">{{ supportEmail }}</a>
      </v-card-text>
      <v-card-text class="d-flex justify-center">
        <v-icon class="mr-1">mdi-phone-in-talk</v-icon>
        {{ $t('phone') }}: <a class="ml-2" :href="`tel:${this.supportPhone}`">{{ supportPhone }}</a>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text class="mt-2">{{ $t('videoDescription') }}</v-card-text>
      <v-flex class="my-5 mx-5 justify-center">
        <iframe width="100%" :src="helpVideoPlayList"
                title="DynamEat video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen/>
      </v-flex>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="$emit('close')">
          {{ $t('accept') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import {
  HELP_PLAYLIST_URL_ES, HELP_PLAYLIST_URL_EN, SUPPORT_EMAIL, SUPPORT_PHONE
} from '@dynameat/constants';
import { Prop } from 'vue-property-decorator';
import { MapGetters } from '@core/helpers/decorators';

@Component
export default class DynameatHelpCard extends Vue {
  @Prop({ Boolean, default: false }) visible;

  @MapGetters(['userLocale'])

  supportEmail = SUPPORT_EMAIL

  supportPhone = SUPPORT_PHONE

  get helpVideoPlayList() {
    if (this.userLocale === 'es') {
      return HELP_PLAYLIST_URL_ES;
    }
    return HELP_PLAYLIST_URL_EN;
  }
}
</script>

<style scoped>

</style>
